/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { killswitchesListMCPServers } from "../funcs/killswitchesListMCPServers.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { KillswitchListMCPServersResult } from "../models/components/killswitchlistmcpserversresult.js";
import {
  KillswitchesListMCPServersRequest,
  KillswitchesListMCPServersSecurity,
} from "../models/operations/killswitcheslistmcpservers.js";
import { unwrapAsync } from "../types/fp.js";
export type KillswitchMCPServersQueryData = KillswitchListMCPServersResult;

export function prefetchKillswitchMCPServers(
  queryClient: QueryClient,
  client$: GramCore,
  security: KillswitchesListMCPServersSecurity,
  request?: KillswitchesListMCPServersRequest | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildKillswitchMCPServersQuery(
      client$,
      security,
      request,
      options,
    ),
  });
}

export function buildKillswitchMCPServersQuery(
  client$: GramCore,
  security: KillswitchesListMCPServersSecurity,
  request?: KillswitchesListMCPServersRequest | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<KillswitchMCPServersQueryData>;
} {
  return {
    queryKey: queryKeyKillswitchMCPServers({
      gramSession: request?.gramSession,
    }),
    queryFn: async function killswitchMCPServersQueryFn(
      ctx,
    ): Promise<KillswitchMCPServersQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(killswitchesListMCPServers(
        client$,
        security,
        request,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyKillswitchMCPServers(
  parameters: { gramSession?: string | undefined },
): QueryKey {
  return ["@gram/client", "killswitches", "listMCPServers", parameters];
}
